'use client'

import { useEffect } from 'react'

const SelectScrollLockFix = () => {
  useEffect(() => {
    const originalSetAttribute = document.body.setAttribute.bind(document.body)
    const originalRemoveAttribute = document.body.removeAttribute.bind(document.body)

    document.body.setAttribute = (name: string, value: string) => {
      originalSetAttribute(name, value)
      if (name === 'data-scroll-locked') {
        document.body.style.setProperty('overflow', 'visible', 'important')
      }
    }

    document.body.removeAttribute = (name: string) => {
      originalRemoveAttribute(name)
      if (name === 'data-scroll-locked') {
        document.body.style.removeProperty('overflow')
      }
    }

    return () => {
      document.body.setAttribute = originalSetAttribute
      document.body.removeAttribute = originalRemoveAttribute
    }
  }, [])

  return null
}

export default SelectScrollLockFix
